import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ImageCard from '../../components/ImageCard/ImageCard'; // Ваш компонент из предыдущего вопроса
import './Cabinetpage.css'
import dining_room_1 from '../../images/Cab_photos/dining_room/3.jpg'
import dining_room_2 from '../../images/Cab_photos/dining_room/4.jpg'
import dining_room_3 from '../../images/Cab_photos/dining_room/5.jpg'

const CabinetPage = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('description');
  
  const cabinetData = {
    id: 1,
    title: "Столовая",
    images: [
      dining_room_1,
      dining_room_2,
      dining_room_3
    ],
    description: <span><b>Школьная столовая — сердце нашего учебного заведения</b><br/> Если спросить учеников или сотрудников о любимом месте в школе, многие, не задумываясь, назовут столовую. И это неудивительно! Здесь царит особая атмосфера: аромат свежеприготовленных блюд, дружеские разговоры за столами и возможность ненадолго отвлечься от уроков. <br/><br/><b>Вкусно, полезно и для всех</b><br/> На завтрак и обед у нас подают разнообразные блюда — от сытных горячих супов и гарниров до лёгких салатов и десертов. Особое внимание уделяется индивидуальным потребностям: в меню всегда есть варианты для тех, кто придерживается диеты, не ест мясо или страдает аллергией.<br/> <br/><b>Свежесть и качество — наш приоритет</b><br/> Вся еда готовится прямо на школьной кухне профессиональными поварами. Благодаря этому мы можем контролировать качество продуктов, соблюдать нормы питания и радовать учеников вкусной, а главное — полезной едой.<br/> <br/><b>Больше, чем просто приём пищи</b><br/> Столовая — это ещё и место для общения. Здесь обсуждаются новости, строятся планы на перемены и даже придумываются совместные проекты. А яркий дизайн и удобные столы делают пространство ещё уютнее. <br/><br/>Так что если хочется перекусить, выпить чаю с душистым печеньем или просто провести время в приятной компании — добро пожаловать в нашу столовую!</span>,

  };

  return (
    <div className="cabinet-page">
      
      <h1 className="cabinet-title">{cabinetData.title}</h1>
      
        <ImageCard 
          images={cabinetData.images} 
          description={'"На уроках хорошо, но в столовой лучше!"'}
        />
        <hr className='razdel'/>
      
      <div className="cabinet-content">
        {activeTab === 'description' && (
          <div className="description-section">
            <p>{cabinetData.description}</p>
          </div>
        )}
      </div>
      <div className="next-floor-button-container">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
    </div>
    </div>
  );
};

export default CabinetPage;